import FileDropAreaHtml from "./FileDropAreaHtml.js";

export default class FileDropAreaCmp {
	_html = new FileDropAreaHtml();

	/**
	 * @param {Element} element
	 * @param {{svgIcon?: string, message?:string, showOverlay?:boolean}?} props
	 */
	init(element, props = {}) {
		this._html.init(element, props);
	}

	onDragEnter(cb) {
		this._html.onDragEnter(cb);
	}

	onDragLeave(cb) {
		this._html.onDragLeave(cb);
	}

	/**
	 * @param {Function} cb - the callback should accept a {@link FileList}
	 */
	onDrop(cb) {
		this._html.onDrop(cb);
	}
}